import { SessionResponse } from '@/ports'
import { useDSLogin } from '@/features/Auth/Context/ds-login-provider'

import useSessionComplete from './use-session-complete'

export const useEnsureLoggedIn = ({ showLogin }: { showLogin: () => void }) => {
  const isLoggedIn = useSessionComplete()
  const { setAfterLogin } = useDSLogin()
  const ensureLoggedIn = (action: (session?: SessionResponse) => void) => {
    if (isLoggedIn) {
      return action()
    }
    setAfterLogin(action)
    showLogin()
  }

  return ensureLoggedIn
}
